<template>
  <div class="panel-categories-old-style">
    <panel-categories-item
      :category="category"
      :category-index="index"
      :categories="categories"
      :is-not-mobile="windowWidth > 768"
      :is-single="categories.length === 1"
      :count="category.count"
      :key="index"
      v-for="(category, index) in categories">
    </panel-categories-item>
  </div>
</template>

<script>
  import PanelCategoriesItem from '@/components/Panel/PanelCategories/PanelCategoriesItemOldStyle';
  import { mapState } from 'vuex';
  // TODO Refacto ce composant à cause des nouveaux style de Panel
  export default {
    name: 'panel-categories-old-style',
    components: { PanelCategoriesItem },
    /**
     * This component will be the container for the Panel categories
     */
    props: {
      /**
       * The categories which will be loop
       */
      categories: Array
    },
    data() {
      return {
        previousCategory: {},
      }
    },
    computed: {
      ...mapState({
        windowWidth: state => state.panel.windowWidth
      }),
    },
  };
</script>

<style scoped lang="scss">
  .panel-categories-old-style {
    background: $color-white;
    flex-shrink: 0;
    min-height: 40px;
    justify-content: center;
    width: 100%;
    margin-top: -1px;
    @include bp('tablet') {
      margin-top: 0;
    }
  }
</style>
